import { UsersIcon } from "@heroicons/react/20/solid"; // mini
import { ClockIcon } from "@heroicons/react/24/outline"; // outline
import React from "react";

const OverviewSheet = ({ numGuards, totalHours }) => (
  <div className="fixed bottom-5 lg:ml-64 -translate-x-1/2 shadow-lg bg-gray-800 text-white rounded-lg text-sm flex items-center px-6 py-2 space-x-8 z-2">
    <div className="flex items-center space-x-2">
      <UsersIcon className="w-5 h-5 text-white" />
      <span>
        {numGuards} {numGuards === 1 ? "guard" : "guards"}
      </span>
    </div>
    <div className="flex items-center space-x-2">
      <ClockIcon className="w-5 h-5 text-white" />
      <span>
        {totalHours} {totalHours === 1 ? "hour" : "hours"}
      </span>
    </div>
  </div>
);

export { OverviewSheet };
